module.exports = __webpack_public_path__ + "static/media/RecomendaCaboFrio.8e23e420.jpg";